<template>
    <div 
        class="o-manage-destination-panel-otg"
        :style="componentStyles"
    >
        <AIconButton
            v-if="componentParams.is_show_back_arrow"
            :icon="componentParams.back_icon ||  'arrow-left-otg-green'"
            :class="`back-button ${componentParams.back_button_class || ''}`"
            @onClick="onClickBack"
            :text="backButtonText"
        />
        <template
            v-if="isShowCloseButtons"
        >
            <OSearchButtonOtg
                @onClick="onClickBack"
            />
            <AIconButton
                v-if="isShowCloseButton"
                :icon="closeIcon"
                class="close-button"
                @onClick="onClickClose"
            />
            <OIntegrationCloseButton />
            <ACloseIcon />
        </template>
        <div 
            class="o-manage-destination-panel-otg__logo"
            v-if="componentParams.is_show_logo"
        >
            <div class="o-manage-destination-panel-otg__logo-image" />
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import ACloseIcon from '../../atoms/a-close-icon';
import AIconButton from '../../atoms/a-icon-button';
import {routerPushHandler} from "@/utils/helpers/common";
import OSearchButtonOtg from '../../unique-organisms/o-search-button-otg';
import { WEB_INTEGRATION } from "../../../utils/constants/route-constants";
import {OBJECT_INFO_CLOSE_CLICK} from "@/utils/constants/bus-events-constants";
import OIntegrationCloseButton from '../../organisms/o-integration-close-button';

export default {
    name: 'OManageDestinationPanel',
    components: {
        ACloseIcon,
        AIconButton,
        OSearchButtonOtg,
        OIntegrationCloseButton
    },
    computed: {
        ...mapGetters([
            'getMapConfigProp'
        ]),
        isStore() {
            return this.$route.name.includes(WEB_INTEGRATION.STORE.ROOT.NAME)
        },
        commonConfigStyles() {
            return this.getMapConfigProp('components.OManageDestinationPanel.styles') || {};
        },
        viewConfigStyles() {
            return this.getMapConfigProp(`views.${this.view}.footer.OManageDestinationPanel.styles`) || {};
        },
        componentStyles() {
            return {
                ...this.commonConfigStyles,
                ...this.viewConfigStyles
            }
        },
        commonConfigParams() {
            return this.getMapConfigProp('components.OManageDestinationPanel.params') || {};
        },
        viewConfigParams() {
            return this.getMapConfigProp(`views.${this.view}.footer.OManageDestinationPanel.params`) || {};
        },
        componentParams() {
            return {
                ...this.commonConfigParams,
                ...this.viewConfigParams
            }
        },
        isShowCloseButton() {
            return this.getMapConfigProp('components.OManageDestinationPanel.params.is_show_close_button', false)
        },
        closeIcon() {
            return this.getMapConfigProp('components.OManageDestinationPanel.params.back_icon', 'close-otg-black')
        },
        backButtonText() {
            return this.componentParams.back_button_text ? this.$t(this.componentParams.back_button_text) : ''
        },
        isShowCloseButtons() {
            if(this.componentParams.hasOwnProperty('is_show_close_buttons')) {
                return this.componentParams.is_show_close_buttons
            }
            return true
        }
    },
    methods: {
        onClickBack() {
            const name = this.isStore ?
                WEB_INTEGRATION.STORE.SETTINGS.NAME :
                WEB_INTEGRATION.CATALOGUE.SETTINGS.NAME;

            const params = {
                name,
                query: {}
            };

            if (this.$route?.query?.t) params.query.t = this.$route.query.t;
            if (this.$route?.query?.mTo) params.query.mTo = this.$route.query.mTo;
            if (this.$route?.query?.mFrom) params.query.mFrom = this.$route.query.mFrom;

            this.$router.push(params);
        },
        onSearchClick() {
            this.$router.push({ name: WEB_INTEGRATION.CATALOGUE.LIST.NAME, query: this.$route.query });
        },
        onClickClose() {
            const name = this.isStore ?
                WEB_INTEGRATION.STORE.INFO.NAME :
                WEB_INTEGRATION.CATALOGUE.LIST.NAME;
            this.$bus.$emit(OBJECT_INFO_CLOSE_CLICK);
            this.$router.push({ name, query: {...this.$route.query, mv: 'OutdoorView'}}, routerPushHandler);
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />
